<template>
  <div class="flex justify-center">
    <CVButton
      variant="ghost"
      class="bg-primary/10 text-orange-900/80 hover:bg-primary/20 flex items-center justify-center rounded-lg px-4 py-2"
      @click="emit('click')"
    >
      <PlusIcon class="size-4" />{{ label }}
    </CVButton>
  </div>
</template>

<script setup lang="ts">
import { PlusIcon } from '@heroicons/vue/24/solid';

defineProps<{
  label: string;
}>();

const emit = defineEmits<{
  (event: 'click'): void;
}>();
</script>
